import * as yup from 'yup'

const salesOrderSchema = yup.object().shape({
  itemName: yup.string().nullable().optional(),
  units: yup.string().nullable().optional(),
  pricePerUnit: yup.string().nullable().optional(),
})

export const arkFoodsOrderConfirmationFileDataSchema = yup.object().shape({
  title: yup.string().nullable().optional(),
  subtitle: yup.string().nullable().optional(),
  customerName: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  expectedDeliveryDate: yup.string().nullable().optional(),
  estimatedNumberOfPallets: yup.string().nullable().optional(),
  isFob: yup.string().nullable().optional(),
  items: yup.array().of(salesOrderSchema).required(),
})

export type ArkFoodsOrderConfirmationFileData = yup.InferType<
  typeof arkFoodsOrderConfirmationFileDataSchema
>

export const arkFoodsOrderConfirmationFileDataMappings = {
  title: 'a2b8f3e1-7c4d-4f9a-b5e6-3d1f8c2a9b7e',
  subtitle: 'b9e4a1f7-3c5d-4e8b-a6c2-7f1d9a3e4c8b',
  customerName: 'a1f5c3d8-4e9b-4a2c-b7e6-1f3d8c5a9b2e',
  poNumber: 'c4e7b2a9-6f1d-4c8b-a3e5-2d7f9a1c4b8e',
  expectedDeliveryDate: 'e8a2f5c1-3d4b-4e9a-b6c7-4f1e8d2a5c9b',
  estimatedNumberOfPallets: 'f3b9e1a7-2c5d-4f8e-a9b4-6d2c8f1a3e7b',
  isFob: '5d9f2b83-7c4e-4a02-8f16-8b3e7d9c2a45',
  items: [
    {
      itemName: 'b7d4e9a2-5f1c-4e8b-a3d6-7f2e9c1a4b8d',
      units: 'd1f8c4e7-3a2b-4f9e-b6c5-8d1f4a2e7c9b',
      pricePerUnit: 'e9c5a1f4-7b2d-4e8a-b3c6-1f9d7a4e2c8b',
    },
  ],
}
